// extracted by mini-css-extract-plugin
module.exports = {"balls":"BouncingBalls_balls__2h2ep","left-swing":"BouncingBalls_left-swing__UsG9t","right-swing":"BouncingBalls_right-swing__3-7Z-"};